module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SitePage"
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/optima-logo-nutrition.png",
      "width": "250px"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showChangelog = true
      }
    }
  }, [_vm._v("\n        Version " + _vm._s(_vm.version) + " (" + _vm._s(_vm.date) + ")\n      ")]), _vm._v(" "), (_vm.showChangelog) ? _c('Changelog', {
    on: {
      "close": function($event) {
        _vm.showChangelog = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Optima Nutrition is currently under development. Development is supported through a partnership\n      between the "), _c('a', {
    attrs: {
      "href": "http://www.burnet.edu.au"
    }
  }, [_vm._v("Burnet Institute")]), _vm._v(" and the "), _c('a', {
    attrs: {
      "href": "http://www.worldbank.org"
    }
  }, [_vm._v("World Bank")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Information about Optima Nutrition is available as a "), _c('a', {
    attrs: {
      "href": "http://ocds.co/appfiles/Optima_Nutrition_Overview.pdf",
      "target": "_blank"
    }
  }, [_vm._v("PDF")]), _vm._v(" or\n      "), _c('a', {
    attrs: {
      "href": "http://ocds.co/appfiles/Optima_Nutrition_Overview.pdf",
      "target": "_blank"
    }
  }, [_vm._v("PowerPoint")]), _vm._v(" presentation.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divTable",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "divTableBody"
  }, [_c('div', {
    staticClass: "divTableRow"
  }, [_c('div', {
    staticClass: "divRowContent",
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "30px"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/burnet-logo-transparent.png",
      "height": "60px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "divRowContent",
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "30px"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/world-bank-logo.png",
      "height": "60px"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-426e25e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/AboutPage.vue
// module id = 375
// module chunks = 1